import React, { useEffect, useState } from 'react';
import {
  StyledMenu,
  StyledMenuItem,
  StyledWarningIcon
} from './styledComponents';
import { useSelector } from 'react-redux';
import { sideMenuContents } from './SideMenuConfig';
import { Link, useLocation } from 'react-router-dom';
import { Tooltip } from 'antd';
import { getAccessData } from '../../../../Apis/Patient Roster';

function SideMenu({ collapsed }) {
  const [theme] = useSelector(state => [state.themeReducer]);
  const location = useLocation();
  const [sideMenuItems, setSideMenuItems] = useState([]);
  const [user] = useSelector(state => [state.userReducer]);
  const [access, setAccess] = useState(true);
  const [activeKey, setActiveKey] = useState(() => {
    const activeItem = sideMenuItems.find(item => {
      let splitPath = location.pathname.split('/');
      let splitLink = item.link.split('/');
      // Check for exact match first
      if (splitPath[2] === splitLink[2]) return item;
      // Check if it's a dictionary-related route (dictionary-facility, dictionary-templates)
      if (splitLink[2] === 'dictionary' && splitPath[2]?.startsWith('dictionary')) return item;
      // Check if it's a facility-management route
      if (splitLink[2] === 'facility-management' && splitPath[2]?.startsWith('facility-management')) return item;
      return null;
    });
    return activeItem ? activeItem.key : '0';
  });

  useEffect(() => {
    if (user) setSideMenuItems(sideMenuContents(user.userType));
    // eslint-disable-next-line
  }, [user]);
  useEffect(() => {
    if (user.userType !== 'reviewer' && user.userType !== 'scribe') {
      getAccessData()
        .then(response => {
          if (response.data.success) {
            // console.log('test1', authorId, access);
            setAccess(true);
            // setLoader(false);
            // setSearchStringFacility(new String(''));
          } else {
            // console.log(access, 'access1');
            setAccess(false);

            // setLoader(false);
          }
        })
        .catch(err => console.log(err));
    }
  }, []);

  useEffect(() => {
    const splitPath = location.pathname.split('/');
    const isEditorRoute = splitPath[2] === 'new-editor' || splitPath[2] === 'editor';

    const activeItem =
      sideMenuItems &&
      sideMenuItems.find(item => {
        let splitLink = item.link.split('/');
        // Map editor routes to the Jobs sidebar item
        if (isEditorRoute && splitLink[2] === 'jobs-list') return item;
        // Check for exact match first
        if (splitPath[2] === splitLink[2]) return item;
        // Check if it's a dictionary-related route (dictionary-facility, dictionary-templates)
        if (splitLink[2] === 'dictionary' && splitPath[2]?.startsWith('dictionary')) return item;
        // Check if it's a facility-management route
        if (splitLink[2] === 'facility-management' && splitPath[2]?.startsWith('facility-management')) return item;
        return null;
      });
    if (activeItem) {
      setActiveKey(activeItem.key);
    } else {
      setActiveKey('0');
    }
  }, [sideMenuItems, location.pathname]);

  const onSelect = param => {
    setActiveKey(param.key);
  };

  return (
    <StyledMenu
      mode='inline'
      defaultSelectedKeys={activeKey}
      theme='light'
      color={theme['@primary-color']}
      textColor={theme['@text-color']}
      collapsed={collapsed}
      onSelect={onSelect}
      key={activeKey}
    >
      {sideMenuItems &&
        sideMenuItems
          .filter(
            config =>
              !(
                !access &&
                config.name === 'Roster' &&
                user.userType !== 'biller'
              )
          )
          .map(config => {
            return (
              <StyledMenuItem
                key={config.key}
                icon={<config.icon />}
                color={theme['@primary-color']}
                disabled={config.disabled || (config.name === 'HL7' && true)}
              >
                <Link to={config.link}>{config.name}</Link>
                {config.name === 'Settings' &&
                  user.userType === 'admin' &&
                  !user.clinicConfigured && (
                    <Link to={config.link}>
                      <Tooltip title='Ehr not Configured.'>
                        <StyledWarningIcon />
                      </Tooltip>
                    </Link>
                  )}
              </StyledMenuItem>
            );
          })}
    </StyledMenu>
  );
}

export default SideMenu;
